import { GameState } from './GameState';
import { LevelTemplateKey } from './templates/LevelTemplate';

export class GameConfig {
  static logDebug: boolean = true;
  static logInfo: boolean = true;
  static initialLives: number = 3;

  debug: boolean = false;

  debugLayer: boolean = true;
  debugFps: boolean = false;
  debugBodies: boolean = false;
  debugNavMesh: boolean = false;
  mute: boolean = false;
  debugPaths: boolean = true;
  debugPathBoundaries: boolean = true;
  sceneViewer: boolean = false;
  godMode: boolean = false;

  levelKey?: string = 'test';
  levelTemplate: LevelTemplateKey = 'Mountains';
  state?: GameState = GameState.MAIN;
  seed?: number;

  /** Room code from ?join= URL parameter for auto-joining multiplayer */
  joinCode?: string;

  /** Base URL for the Platformia server API */
  static get serverUrl(): string {
    const { protocol, hostname, port } = window.location;
    // In development, the frontend is on 3333 and the API on 3334
    if (port === '3333') {
      return `${protocol}//${hostname}:3334/api`;
    }
    // In production or when accessed via LAN IP on a different port,
    // assume the API is at /api on the same host
    return `${protocol}//${hostname}${port ? `:${port}` : ''}/api`;
  }
}
